<template>
    <div class="cloth_card" :style="item.style" draggable="false">
        <img
            v-if="dragged"
            class="minus_icon"
            src="@/assets/img/ppe/minus-icon.png"
            alt="plus icon"
        />
        <img
        
            v-else
            class="plus_icon"
            src="@/assets/img/ppe/plus-icon.png"
            alt="plus icon"
        />
        <figure :class="dragged ? 'cloth_container dragged' : 'cloth_container not_dragged'">
            <div :draggable="!dragged"
                @dragstart="handleDragStart"
                @dragend="handleDragEnd">
                <img
                class="cloth_img"
                :src="mediaPath"
                :alt="item.title" 
            />
            <img :src="mediaPath" ref="dragImage" style="position: absolute; top: -9999px; left: -9999px;" />
            </div>
            <button v-if="dragged" class="cloth_remove" @click="removeItem(item)">Remove</button>
            <p class="cloth_caption">{{ item.title }}</p>
        </figure>
    </div>
</template>

<script>


export default {
    name: "ClothCards",
    props: {

        item: {},
        outfit: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dragged: false,
            itemToDrag: null
        };
    },
    mounted() {
        this.initializeDragged();
        
    },
    watch: {
        outfit: {
            handler: 'initializeDragged',
            deep: true,
            immediate: true,
        },
    },
    methods: {
        handleDragStart(event) {
            // console.log("drag start");
            event.dataTransfer.setData("text/plain", JSON.stringify(this.item));
            this.$emit('item-dragged', this.item);
            const dragImage = this.$refs.dragImage;
            event.dataTransfer.setDragImage(dragImage, 25, 25);
        },
        handleDragEnd() {
            if (this.outfit.some(outfitItem => outfitItem.title === this.item.title)) {
                this.dragged = true;
            }
        },
        removeItem(item) {
            // console.log("remove item", item);
            this.$emit('remove-item', item);
            this.dragged = false;
        },
        handleRemoveAll() {
            this.dragged = false;
        },
        initializeDragged() {
            // console.log("initialize dragged", this.item.title);
            if (this.outfit.length === 0) {
                this.dragged = false;
            } else if (this.outfit.some(outfitItem => outfitItem.title === this.item.title)) {
                this.dragged = true;
            } else {
                this.dragged = false;
            }

        },
    },
    computed: {
        mediaPath() {
            if (this.dragged) {
                return app.api.Utils.getMediaPath(this.item.imageRed.src);
            } else {
                this.itemToDrag = app.api.Utils.getMediaPath(this.item.image.src);
                return app.api.Utils.getMediaPath(this.item.image.src);
            }
        }
        
      
    
    },
};
</script>

<style lang="scss">
.cloth_card {
  
    position: absolute;
}
.cloth_container {
    position: relative;
    width: 100px;
    height: 100px;
  
  
}
.not_dragged {

    border: solid 1px var(--border-green);
    background-color: var(--bg-green);
}
.dragged {
   
    border: dashed 1px #AD503C;
    background-color: #c79c9b83;
}
.cloth_caption {

    user-select: none;
    font-family: "Arla Interface";
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    font-size: 15;
    color: var(--md-black);
    position: absolute;
    width: 150px;
    bottom: -45px;
    left: 50%;
    transform: translate(-50%, -50%);
}
.cloth_remove {
    
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, -50%);
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    font-size: 15px;
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    color: #AD503C;
    z-index: 4;
    cursor: pointer;
}
.cloth_img {

    z-index: 3;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
}
.plus_icon {

    z-index: 4;
    position: absolute;
    top: -15px;
    right: -15px;
}
.minus_icon {
   cursor: pointer;
    z-index: 4;
    position: absolute;
    top: -15px;
    right: -15px;
}
</style>
